//暴露成插件供其他服务调用
import FunASR from "./plugins/FunASR";
export default FunASR;
window.FunASR = FunASR;